import styled from 'styled-components';
import { themeColor } from '@whitelabel/helpers/style';

const StyledSection = styled.section`
  .rich-text-block {
    > h2,
    > h3,
    > h4 {
      margin-bottom: 1rem;
    }
    p,
    li {
      color: ${themeColor('body')};
    }
  }
`;

export default StyledSection;
